import * as React from "react";

import { getGroupedRows, addItemToGoogleTracking } from "../../utils";
import { IExplorerProperties } from "../../models";
import { ExplorerTabDailyPrices, ExplorerTabPerformance, ExplorerTabCharges, ExplorerTabYield } from "../FundExplorerTabs";
import { Selector } from "../Selector/Selector";
import { ResetSearch } from "../ResetSearch/ResetSearch";
import { ResponsiveContainer } from "../ResponsiveContainer/ResponsiveContainer";
import { ToggleButton } from "./ToggleButton/ToggleButton";
import { DownloadButton } from "./DownloadButton/DownloadButton";

import { Tabs } from "../../assets/Tabs/Tabs";
import { TabContents } from "../../assets/TabContents/TabContents";
import { FilterSelector } from "../../assets/FilterSelector/FilterSelector";
import * as changeCase from "change-case";

const styles = require('./Fundpages.pcss');

/*--- Interfaces ---*/

interface IProps {
    isLoading?: boolean;
    currentTab?: string;
}

interface IFundExplorerState {
    activeTab?: number;
    isHovering?: boolean;
}

export class Fundpages extends React.Component<IProps & IExplorerProperties, IFundExplorerState>{
    constructor(props) {
        super(props);

        this.state = {
            isHovering: false,
            activeTab: 0
        };

        this.handleTabClick = this.handleTabClick.bind(this);
    }

    handleTabClick(index) {
        let { appParams } = this.props;
        let tabs = this.getTabs(appParams);
        if (tabs) {
            let tabKey = tabs[index];
            let gaKey = `fund_tab_${ changeCase.snake(tabKey) }`;
            addItemToGoogleTracking(appParams, gaKey, { eventLabel: tabKey });
        }
        this.setState({ activeTab: index });
    }

    getTabs(appParams) {
        let tabs = ['daily prices'];
        let productrange = appParams.productrange.toUpperCase();

        if (productrange !== "PPL" && productrange !== "ICAV") {
            // Remove Performance tab
            tabs = [].concat(...tabs, 'fund charges'/*, 'yield' */); 
            // tabs = [].concat(...tabs, 'performance', 'fund charges'/*, 'yield' */);
        }
        return tabs;
    }

    render() {
        const isViewingWatchlist = location.search.indexOf("isins") >= 0;
        let { funds, filter, toggleAllFunds, isLoading, appParams, sorting, changeSortOrder, getFunds, changeFilter } = this.props;
        let tabs = this.getTabs(appParams);
        let activeTabKey = '';
        if (tabs && tabs.length > this.state.activeTab) {
            activeTabKey = changeCase.camel(tabs[this.state.activeTab]);
        }

        let groupedRows = getGroupedRows(funds);
        let shareClassesAvailable = funds.values.reduce((acc, fund) => {
            acc += fund.shareClasses.length;
            return acc;
        }, 0);

        return (
            <section>
                <DownloadButton activeTabKey={activeTabKey} filter={filter} appParams={appParams} sorting={sorting} getFunds={getFunds} changeFilter={changeFilter} />
                <ToggleButton funds={funds} toggleAllFunds={toggleAllFunds} appParams={appParams} />
                {(() => {
                    if (isViewingWatchlist) {
                        return (
                            <ResetSearch
                                isLoading={isLoading}
                                changeFilter={changeFilter}
                                appParams={appParams}>
                            </ResetSearch>
                        );
                    }
                })()}
                <div className={styles.filterElements}>
                    <FilterSelector type={'Sort by'} appParams={appParams} sorting={sorting} changeSortOrder={changeSortOrder} />
                    <div className={styles.filterResults}>{1}-{shareClassesAvailable}&nbsp;OF&nbsp;{funds.shareClassTotal}&nbsp;RESULTS</div>
                </div>
                <div className={ styles.pageContents }>
                    <ResponsiveContainer breakpoint={ 430 }>
                        <Tabs handleClick={ this.handleTabClick } activeTab={ this.state.activeTab } tabs={ tabs } />
                        <Selector handleClick={ this.handleTabClick } title={ this.state.activeTab } options={ tabs } />
                    </ResponsiveContainer>
                    <TabContents activeContent={this.state.activeTab}>
                        <ExplorerTabDailyPrices {...this.props} groupedRows={groupedRows} />
                        {/* Remove Performance Tab contents */}
                        {/* <ExplorerTabPerformance {...this.props} groupedRows={groupedRows} /> */}
                        <ExplorerTabCharges {...this.props} groupedRows={groupedRows} />
                        <ExplorerTabYield {...this.props} groupedRows={groupedRows} />
                    </TabContents>
                </div>
            </section>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/FundPages/Fundpages.tsx